import { GOOGLE_SPOT } from '../../constants';
export function resetGoogleSpotPayments(payload) {
    return {
        type: GOOGLE_SPOT.RESET_PAYMENTS,
        payload,
    };
}
export function googleSpotInitiatePayment(payload) {
    return {
        type: GOOGLE_SPOT.INITIATE_PAYMENT_REQUEST,
        payload,
    };
}
export function googleSpotInitiatePaymentSuccess(response) {
    return {
        type: GOOGLE_SPOT.INITIATE_PAYMENT_REQUEST_SUCCESS,
        response,
    };
}
export function googleSpotInitiatePaymentFailure() {
    return {
        type: GOOGLE_SPOT.INITIATE_PAYMENT_REQUEST_FAILURE,
    };
}
export function googleSpotValidateResponse(payload) {
    return {
        type: GOOGLE_SPOT.VALIDATE_RESPONSE,
        payload,
    };
}
export function googleSpotValidateResponseSuccess(response) {
    return {
        type: GOOGLE_SPOT.VALIDATE_RESPONSE_SUCCESS,
        response,
    };
}
export function googleSpotValidateResponseFailure() {
    return {
        type: GOOGLE_SPOT.VALIDATE_RESPONSE_FAILURE,
    };
}
export function googleSpotCheckTransactionStatus(payload) {
    return {
        type: GOOGLE_SPOT.CHECK_TRANSACTION_STATUS,
        payload,
    };
}
export function googleSpotCheckTransactionStatusSuccess(response) {
    return {
        type: GOOGLE_SPOT.CHECK_TRANSACTION_STATUS_SUCCESS,
        response,
    };
}
export function googleSpotCheckTransactionStatusFailure() {
    return {
        type: GOOGLE_SPOT.CHECK_TRANSACTION_STATUS_FAILURE,
    };
}
